<template>
  <div class="seller-list">
    <Row>
      <Col :xs="24"
           :sm="24">
      <Form :model="formItem"
            ref="formItem"
            :inline="true"
            action="javascript:void(0)">
        <FormItem>
          <Input v-model="formItem.key"
                 clearable
                 placeholder="输入平台名称查找..."></Input>
        </FormItem>
        <FormItem>
          <Button type="primary"
                  @click="renderTable(1)">查找</Button>
        </FormItem>
        <FormItem>
          <Button @click="addGoodCate"
                  type="success"
                  class="f-r">添加平台</Button>
        </FormItem>
      </Form>
      </Col>
    </Row>
    <Table border
           :columns="list"
           :data="tablelist"
           :loading="dataloading"></Table>
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;">
        <Page ref="listPage"
              :total="pages.total"
              :current="pages.page"
              :page-size="pages.size"
              show-elevator
              show-total
              @on-change="changePage()"></Page>
      </div>
    </div>
    <Modal v-model="showModalStatus"
           title="添加平台"
           @on-ok="editgoods()"
           :loading="loading">
      <Form :model="seller">
        <FormItem label="名称"
                  label-position="top">
          <Input v-model="seller.company"
                 style="width:200px"></Input>
        </FormItem>
        <FormItem label="积分回调地址"
                  label-position="top">
          <Input v-model="seller.callback_url"
                 style="width:200px"></Input>
        </FormItem>
        <FormItem label="同步商品地址"
                  label-position="top">
          <Input v-model="seller.tongbu_good_url"
                 style="width:200px"></Input>
        </FormItem>
        <FormItem label="同步商品详情地址"
                  label-position="top">
          <Input v-model="seller.tongbu_gooddetail_url"
                 style="width:200px"></Input>
        </FormItem>
        <FormItem label="同步商品回调地址"
                  label-position="top">
          <Input v-model="seller.tongbu_good_callbackurl"
                 style="width:200px"></Input>
        </FormItem>
        <FormItem label="Icon">
          <upload-thumb v-model="seller.thumb"
                        :ref="thumbRefList[0]"
                        :defaultList="thumblist[0]"
                        :autoCropWidth="154"
                        :autoCropHeight="154"
                        style="width:200px"
                        :defaultTip="'图片格式:jpg、jpeg、png、gif,建议图片尺寸:154*154'"></upload-thumb>
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>
  
  <script>
import UploadThumb from "../common/thumb";
export default {
  name: "seller-list",
  data () {
    return {
      viewerOptions: {
        toolbar: true,
        url: "data-source"
      },
      viewerImages: [],
      loading: false,
      //抽屉参数
      value3: false,
      isable: false,
      thumbRefList: [
        "zero",
        "one",
      ],
      thumblist: [[], []],
      styles: {
        height: "calc(100% - 55px)",
        overflow: "auto",
        paddingBottom: "53px",
        position: "static"
      },

      seller: {},
      isClear: false,
      loading: true,
      dataloading: true,
      currentId: 0,
      title: "编辑",
      pages: {
        page: 1,
        size: 10
      },
      formItem: {
        key: ""
      },
      list: [
        {
          title: "ID",
          key: "id",
          width: 150
        },
        {
          title: "名称",
          key: "company",
        },
        {
          title: "唯一标识",
          key: "code",
        },
        {
          title: "操作",
          key: "action",
          width: 200,
          align: "left",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px"
                  },
                  props: {
                    type: "primary",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.detail(params.row.id);
                    }
                  }
                },
                "编辑"
              ),
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px",
                    display:
                      params.row.id != "3"
                        ? "inline-block"
                        : "none"
                  },
                  props: {
                    type: "error",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.remove(params.row.id);
                    }
                  }
                },
                "删除"
              )
            ]);
          }
        }
      ],
      tablelist: [],
      showModalStatus: false,
      status: 1
    };
  },
  created: function () {
    this.getTableList();
  },
  components: {
    UploadThumb
  },
  watch: {},
  methods: {
    getTableList: function () {
      this.renderTable(1);
    },
    addGoodCate: function () {
      this.thumblist = [[], []];
      this.seller.id = 0;
      this.currentId = 0;
      this.seller.company = "";
      this.seller.callback_url = "";
      this.seller.tongbu_good_url = "";
      this.seller.tongbu_gooddetail_url = "";
      this.seller.tongbu_good_callbackurl = "";
      this.showModalStatus = true;
    },
    // 详情
    detail (index) {
      this.thumblist = [[], []];
      this.showModalStatus = true;
      this.currentId = index;
      this.$api.tongbucompany.detail({ id: index }).then(res => {
        if (res.code == 200) {
          this.seller = res.result;
          this.pushThumbData([
            this.seller.thumb,
          ]);
          this.$Message.success(res.msg);
        } else {
          this.$Message.success(res.msg);
        }
      });
    },
    pushThumbData (list) {
      for (var s = 0; s < list.length; s++) {
        if (list[s] != null && list[s] != "") {
          console.log(this.thumblist);
          this.thumblist[s].push({
            name: list[s],
            url: list[s],
            status: "finished"
          });
        }
      }
    },
    // 修改
    editgoods (name) {
      if (
        this.currentId == null ||
        this.currentId == 0 ||
        this.currentId == ""
      ) {
        this.$api.tongbucompany.create(this.seller).then(res => {
          if (res.code == 200) {
            this.showModalStatus = false;
            this.getTableList();
          }
        });
      } else {
        this.$api.tongbucompany.edit({ 'company': this.seller.company, 'thumb': this.seller.thumb, 'callback_url': this.seller.callback_url, 'tongbu_good_callbackurl': this.seller.tongbu_good_callbackurl, 'tongbu_gooddetail_url': this.seller.tongbu_gooddetail_url, 'tongbu_good_url': this.seller.tongbu_good_url, 'id': this.currentId, }).then(res => {
          if (res.code == 200) {
            this.getTableList();
            this.showModalStatus = false;
          }
          this.loading = false;
          this.$nextTick(() => {
            this.loading = false;
          });
        });
      }
    },
    // 删除
    remove: function (id) {
      // 弹出确认框
      this.$Modal.confirm({
        title: "警告",
        content: "<p>此操作不可恢复，三思而后行...</p>",
        onOk: () => {
          this.$api.tongbucompany.remove({ id: id }).then(res => {
            if (res.code == 200) {
              this.$Message.success(res.msg);
              this.getTableList();
            }
          });
        }
      });
    },
    // 翻页
    changePage () {
      this.pages.page = this.$refs["listPage"].currentPage;
      this.renderTable(1);
    },
    // 筛选
    renderTable: function (name) {
      if (name != 1) {
        this.pages.page = 1;
      }
      this.dataloading = true;
      this.tablelist = [];
      var ps = {
        key: this.formItem.key,
        page: this.pages.page,
        size: this.pages.size
      };
      this.$api.tongbucompany.list(ps).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      return;
    },
  }
};
  </script>
  
  <style>
.demo-drawer-footer {
  width: 100%;
  height: 50px;
  position: absolute;
  bottom: 0;
  left: 0;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  background: #fff;
}
</style>
  
